module.exports = __webpack_public_path__ + "static/img/kmp769-663-37583.437f387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/kmp769-663-37583.jpg
// module id = Xd+7
// module chunks = 0